window.ProposalBuilder = {
	
	structure : {
		propdoc	    : null, 
		settings	: {},
		blocks		: {}
	},
	
	draggable : null,
	
	init : function(){
		var formID	 = "builderForm";
		var formData = {action : 'record'};
		MyTabs.initHorizontal(formID);
        window.onload = function() {
            ProposalBuilder.initDragAndDrop();
        };
		var options = {
			data : formData,
			dataType : 'json',
			beforeSend : function(jqXHR, settings){
				var tabStructure = $.makeArray(ProposalBuilder.structure);
				settings.data += "&"+$.param({proposal_structure : tabStructure[0]});
			},
			success : function(data){
				if (data.error) {
					Push.error(data.error.message);
					MyFacture.stopWait();
					return;	
				}


				var formOk = MyForm.processJson(data, formID);
				MyFacture.stopWait();
				
				
				$('#proposal_id').val(data.proposalid);
				
				if(!formOk){
					var errors = [];
					
					for (var i in data.form.fields){
						if(data.form.fields[i].status != 'ok'){
							errors.push('<li>'+data.form.fields[i].msg+'</li>');
						}
					}
					
					if(errors.length > 0){
						MyWindow.alert('<ul>'+errors.join("\n")+'</ul>', {type : 'error'});
					}
					
					/**
					 * @todo : callback to overview (or not!)
					 */
				}
			}
			
			/* move file uploaders */
		};
		$('#proposal_ident').off('change').on('change', function(){
			$("#proposal_identHasChanged").val("1");
		});
		ProposalBuilder.bindHeaderFooterEvents('header');
		ProposalBuilder.bindHeaderFooterEvents('footer');
		ProposalBuilder.bindAddressEvents();
		$('#proposal_pagination_active').bind('change', function(){
			if($(this).is(':checked')){
				$('.pagination_activeParams').slideDown('fast');
			}else{
				$('.pagination_activeParams').slideUp('fast');
			}
		});
		MyForm.prepare(formID, 'proposal_builder', options, true);
		
		$(window).bind('beforeunload', function() { 
			return Loc.g('Quitter sans enregistrer ?');
		});

		$('.sliderBtn').bind('click', function(){
			if($('#colparams').css('right') == '0px'){
				$('#colparams').css('right', '-'+($('#colparams .colparams-sidebar').outerWidth())+'px');
				$('#colparams .sliderBtn i').addClass('fa-expand').removeClass('fa-compress');
				
			}else{
				$('#colparams').css('right', '0px');
				$('#colparams .sliderBtn i').addClass('fa-compress').removeClass('fa-expand');
			}
		});
		Qtip.init();
		MyFacture.customForm('#colparams');
        setTimeout(function(){
            MyFacture.stopWait();
        }, 1500);
		
	},
	
	initDragAndDrop : function() {
		var existingStructure = $('textarea#structure').val();
		if (existingStructure.length != '') {
			ProposalBuilder.structure = JSON.parse($('textarea#structure').val());
		}
		
		$("#docPreview").ready(function () {

			$("#docPreview").contents().unbind('click').on('click', 'a:not(.options a)', function (e) {
				window.parent.window.open($(this).attr('href'));
				return false;
			});
			


			ProposalBuilder.draggable = $(".available-block").draggable({
				helper				: "clone",
//				revert				: 'invalid',
				tolerance			: "pointer",
//				cursor				: 'pointer',
				cursorAt			: { left: 0 , top : 0},
				opacity				: 1,
				iframeFix			: true,
				revertDuration		: 200,
				zIndex				: 10000,
				connectToSortable	: $("#docPreview").contents().find("#drop-area"),
//				scope				: $("#docPreview").contents().find("#drop-area"),
				scroll				: false, 
				drag				: function(event, ui){
					
					if(ui.helper.closest('body').attr('id') === 'proposalBuilder'){
						var iframeOffset = $("#docPreview").offset();
						ui.position.top		-= iframeOffset.top;
						ui.position.top		+= $("#docPreview").contents().scrollTop();
						ui.position.left	-= iframeOffset.left ;
					}
				}
			});
			
			
			var scrollingSensitivity = 20, scrollingSpeed = 60;

			$("#docPreview").contents().find("#drop-area").sortable({
				items				: '.propBlock',
				axis				: 'y',
				handle				: '.handler',
//				tolerance			: "pointer",
				placeholder			: 'builderPlaceholder',
				iframeFix			: true,
				cursorAt			: {top:0, right:0},
				scroll				: true,

				start: function (e, ui) {
					ui.placeholder.height(ui.helper.outerHeight());
					ui.placeholder.html('<div style="text-align:center;color:#FFF;z-index:1000;color: #2E4554;">' + Loc.g('Déposer le bloc ici') + '</div>');
					ui.helper.css('background-color', '#fff');
				},
				stop : function(e, ui){
					ui.item.css('height', '').css('overflow', '').css('z-index', '');
				},
				receive: function (event, ui) {

					var block = {};
					$("#docPreview").contents().find('.blockPlaceholder').fadeOut('fast');

					block.id	= Math.ceil(Math.random() * 10000)+Math.ceil(Math.random() * 10000)+Math.ceil(Math.random() * 10000)+Math.ceil(Math.random() * 10000);
					block.type	= ui.item.data('template');

					var defaultParams = $.extend(true,{},ui.item.data('defaultparams'));
					block.data = defaultParams;

					ProposalBuilder.structure.blocks[block.id] = block;

					var $element = $('<div class="propBlock ' + block.type+ '" id="block-' + block.id + '">' + ui.item.find('.elementBlock').html() + '</div>'); //   onclick="window.parent.CampaignForm.blockSettings('+block.id+');"
//					$element.find('.editBtn').attr('onclick', 'window.parent.ProposalBuilder.blockSettings(' + block.id + ');');
					$element.find('.deleteBtn').attr('onclick', 'window.parent.ProposalBuilder.deleteBlock(' + block.id + ');');

					$(this).data().uiSortable.currentItem.replaceWith($element);

					ProposalBuilder.blockSettings(block.id);
					ProposalBuilder.checkBlockAvailability();

					$element.on('click', function(e){
						ProposalBuilder.blockSettings(block.id);
					});

					if(block.type == 'toc'){
						ProposalBuilder.updateTOCBlock(block.id);
					}



				},
				sort: function(event, ui){

					var bodyScroll		= parseInt($("#docPreview").contents().find('body').scrollTop(), 10);

					var placeholderPos		= ui.placeholder.position();
					var placeholderHeight	= ui.placeholder.height();
					var newTopPosition		= parseInt(placeholderPos.top, 10) + bodyScroll;


					if(bodyScroll > 0 && ui.item.hasClass('ui-draggable')){

						var lastChildID			= $("#docPreview").contents().find('.propBlock:last').attr('id');
						var placeholderAbove	= false;

						$("#docPreview").contents().find('.propBlock, .blockPlaceholder').each(function(){

							var start	= $(this).position();
							var height	= parseInt($(this).innerHeight(), 10) + parseInt($(this).css('paddingTop'), 10) + parseInt($(this).css('paddingBottom'), 10);
							var end		= start.top + height;
							var middle	= start.top + Math.floor(height / 2);

							if($(this).hasClass('blockPlaceholder')){
								placeholderAbove = true;
							}else{

								if(newTopPosition >= start.top && newTopPosition < end && $(this).attr('id') == lastChildID){
									ui.placeholder.insertAfter($(this));
								} else if(newTopPosition >= start.top && newTopPosition < end){
									if(newTopPosition < middle){
										ui.placeholder.insertBefore($(this));
									}else{
										ui.placeholder.insertAfter($(this));
									}
								}else if(newTopPosition > end && $(this).is(':last')){
									ui.placeholder.insertAfter($(this));
								}
							}

						});

					}
				},

				update: function (event, ui) {
					var sortRes = $(this).sortable('toArray');
					var newStructure = {};

					for (var cpt in sortRes) {

						var blockParts = sortRes[cpt].split('-');

						if (blockParts[1] != undefined && ProposalBuilder.structure.blocks[blockParts[1]] != undefined) {
							ProposalBuilder.structure.blocks[blockParts[1]].rank = cpt;
							newStructure[blockParts[1]] = ProposalBuilder.structure.blocks[blockParts[1]];
						}
					}
					ProposalBuilder.structure.blocks = newStructure;
				}
			});


			$(this).contents().find("#drop-area").on('mousemove mouseup', function (event) {
				$(parent.document).trigger(event);
			});
			
			
			$(this).contents().find("#drop-area").on('mousemove mouseup', function (event) {
				$(parent.document).trigger(event);
			});
			
			$(this).contents().find("#drop-area .toc").each(function(){
				var blockID = $(this).data('blockid');
				ProposalBuilder.updateTOCBlock(blockID);
			})
			
			$(this).contents().find('.propBlock').on('click', function(e){
				ProposalBuilder.blockSettings($(this).data('blockid'));
			});
			$(this).contents().find('.propBlock .options a:not(.deleteBtn)').unbind('click').bind('click', function(e){e.preventDefault();});
			
			ProposalBuilder.checkBlockAvailability();

		});	
	},
	
	checkBlockAvailability : function(){
		if($('#docPreview').contents().find('.signature').length > 0){
			$("#blocksList li[data-template='signature']").addClass('disabled-block');
			$("#blocksList li[data-template='signature']").draggable('disable');
		}else{
			$("#blocksList li[data-template='signature']").removeClass('disabled-block');
			$("#blocksList li[data-template='signature']").draggable('enable');
		}
	},
	
	blockSettings : function(blockID){
		
		if(ProposalBuilder.structure.blocks[blockID] == undefined){
			return false;
		}
		
		var block = ProposalBuilder.structure.blocks[blockID];
		
		if(!$('.tab-h-menu #editorContent').parent('li').hasClass('current')){
			$('.tab-h-menu #editorContent').trigger('click');
		}
		
		$('.blockEditor').empty().hide();
		
		MyFacture.post('proposal_builder', {action : 'templateForm', blockID : block.id, type : block.type}, function(data){
			var $blockForm = $(data.form);
			
			
			for(var cpt in block.data){
				var content	= block.data[cpt];
				var $input	= $blockForm.find(':input[name='+cpt+']');
				if($input.hasClass('redactor')){
					$input.html(content);
				}else if ($input.attr('type') == 'checkbox'){

					if(content == 1 || content == 'Y' || content === true){
						$input.attr('checked', true);
					}
				}else{
					$input.val(content);
				}
			}
			
			$('#docPreview').contents().find('.propBlock').removeClass('blockEdit');
			$('#docPreview').contents().find('#block-'+blockID).addClass('blockEdit');
			
			$('.blockEditorPlaceholder').hide();
			$blockForm.appendTo('.blockEditor');
			$('.blockEditor').fadeIn('fast');
			
			var redactorOpts = {
				changeCallback: function(content){
					var blockID		= $(this)[0].$element.closest('form').find('input[name=blockID]').val();
					var textBlock	= $(this)[0].$element.attr('name');
					var block		= ProposalBuilder.structure.blocks[blockID];
					
					var carriageReg = new RegExp("\n|\r|\t", 'g');
					content = content.replace(carriageReg, "");
					
					$("#docPreview").contents().find('#block-'+blockID+" ."+textBlock).html(content.trim());
					block.data[textBlock] = content.trim();
				},
				minHeight		: 150,
				shortcuts		: false,

				tidyHtml		: false, 
				removeEmptyTags : false,
				linebreaks		: true,
				toolbarOverflow : true,
				
				buttons : [
					'bold', 'italic', 'underline', 'deleted', '|',
					'unorderedlist', 'orderedlist', 'indent', 'outdent', 'table', '|', 'alignment', '|', 'horizontalrule'
				],
				plugins : ['fontsizePDF', 'fontfamily', 'fontcolor', 'proposalRelatedTags', 'proposalLinkedTags', 'proposalCommonsTags']
			};
			
			
			$('.redactor').redactor(redactorOpts);
			
			$('.blockEditor form').unbind('submit').bind('submit', function(){
				$('.blockEditor').fadeOut('fast', function(){
					$('.blockEditorPlaceholder').fadeIn('fast');
				});
				$('#docPreview').contents().find('.propBlock').removeClass('blockEdit');

				return false;
			});
			
			
			$('.blockEditor form :input').bind('change', function(){
				var blockID		= $(this).closest('form').find('input[name=blockID]').val();
				var inputType	= $(this).closest('.form-group').data('type');
				
				if(ProposalBuilder.structure.blocks[blockID].data == undefined){
					ProposalBuilder.structure.blocks[blockID].data = {};
				}
				ProposalBuilder.structure.blocks[blockID]['data'][$(this).attr('name')] = $(this).val();
			});
			
			
			$('.blockEditor form :input[type=checkbox]').unbind('change').bind('change', function(){
				var blockID		= $(this).closest('form').find('input[name=blockID]').val();
				var checkName = $(this).attr('name');
				var val = $(this).is(':checked') ? 'Y' : 'N';

				ProposalBuilder.structure.blocks[blockID].data[checkName] = val;
			});
			
			
			
			MyFacture.customForm('#emailBlockForm');
			
			for(var cpt in block.data){
				var content	= block.data[cpt];
				var $input	= $blockForm.find(':input[name='+cpt+']');
				if(cpt == 'docid' && content != ''){
					$blockForm.find(':input[name='+cpt+']').tokenInput('add', {id : content, name : block.data.docname});
				}
			}
			
		$('.colorpicker').colpick({
				layout:'hex',
				submit:0,
				colorScheme:'light',
				onChange:function(hsb, hex, rgb, el, bySetColor) {
					var blockID		= $(el).closest('form').find('input[name=blockID]').val();

					$(el).parent().find('.append').css('background-color','#'+hex);
					// Fill the text box just if the color was set using the picker, and not the colpickSetColor function.
					$(el).val(hex);
					ProposalBuilder.structure.blocks[blockID].data[$(el).attr('name')] = hex;

					switch($(el).attr('name')){
						case "color" : 
							$("#docPreview").contents().find('#block-'+blockID+'').css('color', '#'+hex);
							break;
					}
				}
			}).unbind('keyup').keyup(function(){
				$(this).colpickSetColor(this.value);
			}).trigger('keyup');
			
			// Specific behavior for document widget
			if($('#emailBlockForm #doctodisplay').length > 0){

				if($('#proposal_relatedtype').val() != 'document'){
					$('#doctodisplay').find('option[value=related]').attr('disabled', 'disabled');
					$('#doctodisplay').val('custom');
				}
				
				if($('#doctodisplay').val() == 'related'){
					$('#emailBlockForm .form-group:eq(1)').hide();
				}
			}
			
			if($('#colparams').css('left') != '0px'){
				$('#colparams').css('left', 0);
			}

		}, 'json');
	},
	
	deleteBlock : function(blockID){
		
		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Non'), 
					click : function(){$(this).dialog('close');}
				},
				{
					text : Loc.g('Oui'), 
					click : function(){
						$(this).dialog('close');
						delete ProposalBuilder.structure.blocks[blockID];
						
						if($('.blockEditor').find('input[name=blockID]').val() == blockID){
							$('.blockEditor').fadeOut('fast', function(){
								$(this).empty();
								$('.blockEditorPlaceholder').fadeIn('fast');
							});
						}
						
						$("#docPreview").contents().find('#block-'+blockID).slideUp(400, function(){
							$(this).remove();
							ProposalBuilder.checkBlockAvailability();
							
							
							if($("#docPreview").contents().find('.propBlock').length == 0){
								$('#docPreview').contents().find('.blockPlaceholder').fadeIn('fast');
							}
							
						});
						
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Supprimer ce bloc ?"), options);
	},
	
	updateImage: function (elt) {
		var blockID = $(elt).closest('form').find('input[name=blockID]').val();
		var formID = 'imageForm';

		var imageData = {'image': ProposalBuilder.structure.blocks[blockID].data};
		var data = $.extend(imageData, {action: 'imageForm', linkedtype : 'proposal',  linkedid : ProposalBuilder.structure.propdoc});

		var options = {
			title: Loc.g('Choisir une image'),
			buttons:
					[
						{
							text: Loc.g("Annuler"),
							click: function () {
								$(this).dialog("close");
							}
						},
						{
							text: Loc.g("Enregistrer"),
							click: function () {
								$("#" + formID).submit();
							}
						}
					],
			width: 980,
			callback: function () {
				$('.file-selector .nano').nanoScroller({preventPageScrolling: true});

				var formOpts = {
					data: {action: 'recordImage', blockID: blockID, linkedtype : 'proposal',  linkedid : ProposalBuilder.structure.propdoc},
					dataType: 'json',
					success: function (data) {

						var formOK = MyForm.processJson(data, formID);
						if (formOK) {

							switch (data.image.imageType) {
								case 'link' :
									ProposalBuilder.structure.blocks[blockID].data['imagetype'] = data.image.imageType;
									ProposalBuilder.structure.blocks[blockID].data['url'] = data.image.url;

									$("#docPreview").contents().find('#block-' + blockID + " img").attr('src', data.image.url).css('max-width', '100%');
									break;
								case 'briefcase' :
									ProposalBuilder.structure.blocks[blockID].data['imagetype'] = data.image.imageType;
									ProposalBuilder.structure.blocks[blockID].data['fileid'] = data.image.fileid;
									ProposalBuilder.structure.blocks[blockID].data['url'] = data.image.url;

									$("#docPreview").contents().find('#block-' + blockID + " img").attr('src', data.image.url).css('max-width', '100%');

									break;
							}

							MyWindow.close();
						}

					}
				};

				MyForm.prepare(formID, 'imagePicker', formOpts, true);
			}
		};

		MyWindow.load('imagePicker', data, options);
	},
	
	
	recordIt : function(callbackAction){
		
		$(window).unbind('beforeunload');
		
		$('#builderForm').find('input[name=callbackAction]').val(callbackAction);
		MyFacture.startWait();
		$('#builderForm').submit();
	},
	
	
	updateText : function(elt, type){
		type			= type === undefined ? '' : type;
		var blockID		= $(elt).closest('form').find('input[name=blockID]').val();
		var name		= $(elt).attr('name');
		var text		= $(elt).val().trim();

		switch(type){
			case 'alt' : 
				ProposalBuilder.structure.blocks[blockID].data[name] = text;
				$("#docPreview").contents().find('#block-'+blockID+" img").attr('alt', text);
				break;
			default : 
				ProposalBuilder.structure.blocks[blockID].data[name] = text;
				$("#docPreview").contents().find('#block-'+blockID+" ."+name).text(text);
				break;
		}
	},
	
	
	updateHeading : function(elt, classname){ 
		var blockID		= $(elt).closest('form').find('input[name=blockID]').val();
		var name		= $(elt).attr('name');
		var level		= $(elt).val();
		
		var title = $("#docPreview").contents().find('#block-'+blockID+" ."+classname).text();

		$("#docPreview").contents().find('#block-'+blockID+" ."+classname).replaceWith('<h'+level+' class="'+classname+'">'+title+'</h'+level+'>');
	},
	
	
	changeImagePosition : function(elt){
		var blockID		= $(elt).closest('form').find('input[name=blockID]').val();
		var name		= $(elt).attr('name');
		var value		= $(elt).val();
		
		ProposalBuilder.structure.blocks[blockID].data[name] = value;
		
		var $block = $("#docPreview").contents().find('#block-'+blockID);
		switch(ProposalBuilder.structure.blocks[blockID].type){
			case 'imagetext' : 
				var $imgBlock = $block.find('.imageblock');
				$block.find('.imageblock').remove();
				if(value == 'left'){
					$imgBlock.insertBefore($block.find('.textblock'));
				}else if(value == 'right'){
					$imgBlock.insertAfter($block.find('.textblock'));
				}
				break;
			case 'image' : 
				var $imgBlock = $block.find('.imageblock');
				$imgBlock.css('text-align', value);
				break;
			case 'heading' : 
				var $imgBlock = $block.find('.heading');
				$imgBlock.css('text-align', value);
				break;
		}
	},
	
	
	
	changeImageSize : function(elt){
		var blockID		= $(elt).closest('form').find('input[name=blockID]').val();
		var name		= $(elt).attr('name');
		var value		= $(elt).val();
		
		if(value != ''){
			var $block = $("#docPreview").contents().find('#block-'+blockID+' img').width(value);
		}else{
			var $block = $("#docPreview").contents().find('#block-'+blockID+' img').css('width', '');
		}
		
	},
	

	addImage: function (imageData, linkedtype, linkedid) {
		$.ajax({
			url: '/?_f=imagePicker',
			data: {action: 'loadBriefcase', linkedtype: linkedtype},
			dataType: 'json',
			success: function (data) {
				$('#briefcaseContent').empty();
				$('#briefcaseContent').html(data.briefcase);


				if (imageData.file_infos.file_id != undefined) {
					CampaignForm.selectBriefcaseImage(imageData.file_infos.file_id);
				}
			}
		});
	},
	
	
	updateLayout : function(layout, type) {
		$('#docPreview').contents().find('#' + type + ' .textblock').removeClass('acenter');
		var content = type == 'header' ? $('.headredactor').val() : $('.footredactor').val();
		switch (layout) {
			case 'text' :
				$('#docPreview').contents().find('#' + type + ' .logoblock').hide();
				$('#docPreview').contents().find('#' + type + ' .textblock').attr('class', 'textblock col-sm-12 col-md-12 col-lg-12').show().html(content);

				$('#' + type + '_params .prefsText').show();
				$('#' + type + '_params .prefsLogo').hide();

				break;
			case 'logotext' :
				$('#docPreview').contents().find('#' + type + ' .logoblock').attr('class', 'logoblock col-sm-4 col-md-4 col-lg-4').show();
				$('#docPreview').contents().find('#' + type + ' .textblock').attr('class', 'textblock col-sm-8 col-md-8 col-lg-8').show().html(content);

				$('#' + type + '_params .prefsText').show();
				$('#' + type + '_params .prefsLogo').show();
				$('#proposal_' + type + '_logoposition option[value="center"]').attr('disabled', 'disabled');
				
				if($('#proposal_' + type + '_logoposition').val() == 'center'){
					$('#proposal_' + type + '_logoposition').val('left');
				}
				
				$('#proposal_' + type + '_logoposition').trigger('change');
				$('#proposal_'+type+'_logotype').trigger('change');
			
				break;
			case 'logo' :
				$('#docPreview').contents().find('#' + type + ' .textblock').hide();
				$('#docPreview').contents().find('#' + type + ' .logoblock').attr('class', 'logoblock col-sm-12 col-md-12 col-lg-12').show();


				$('#' + type + '_params .prefsText').hide();
				$('#' + type + '_params .prefsLogo').show();
				$('#proposal_' + type + '_logoposition option[value="center"]').removeAttr('disabled');
				$('#proposal_' + type + '_logoposition').trigger('change');
				break;
			case 'auto' :
				$('#docPreview').contents().find('#' + type + ' .logoblock').hide();
				$('#docPreview').contents().find('#' + type + ' .textblock').attr('class', 'textblock col-sm-12 col-md-12 col-lg-12 acenter').show().html($('#corpFooter').html());


				$('#' + type + '_params .prefsText').hide();
				$('#' + type + '_params .prefsLogo').hide();
				break;
		}	
	},
	
	bindHeaderFooterEvents : function(type){
		
		
		$("#docPreview").ready(function () {
			// display
			$('#proposal_'+type+'_active').on('change', function(){
				if($(this).is(':checked')){
					$('#docPreview').contents().find('#'+type+':hidden').slideDown(350);
					$('#'+type+'_params .'+type+'_activeParams').show();
				}else{
					$('#docPreview').contents().find('#'+type+':visible').slideUp(350);
					$('#'+type+'_params .'+type+'_activeParams').hide();
				}
				
				ProposalBuilder.updateLayout($('input[name=proposal_'+type+'\\[layout\\]]:checked').val(), type);
			});
			

			ProposalBuilder.updateLayout($('input[name=proposal_'+type+'\\[layout\\]]:checked').val(), type);

			$('input[name=proposal_'+type+'\\[layout\\]]').bind('change', function(){
				ProposalBuilder.updateLayout($(this).val(), type);
			});
			
			
			switch(type){
				case 'header':
					
					var redactorOpts = {
						changeCallback: function (content) {
							var textBlock = $(this)[0].$element.attr('name');
							var carriageReg = new RegExp("\n|\r|\t", 'g');

							content = content.replace(carriageReg, "");

							$("#docPreview").contents().find('#header .textblock').html(content.trim());
						},
						minHeight: 150,
						shortcuts: false,
						tidyHtml: false,
						removeEmptyTags: false,
						linebreaks: true,
						buttons: [
							'bold', 'italic', 'underline', 'deleted', '|',
							'unorderedlist', 'orderedlist', 'indent', 'outdent', 'alignment', '|', 'horizontalrule'
						],
						plugins: ['fontsize', 'fontfamily', 'fontcolor', 'proposalRelatedTags', 'proposalLinkedTags', 'proposalCommonsTags']
					};


					$('.headredactor').redactor(redactorOpts);
					break;
				case 'footer':
					var redactorOpts = {
						changeCallback: function (content) {
							var textBlock = $(this)[0].$element.attr('name');
							var carriageReg = new RegExp("\n|\r|\t", 'g');

							content = content.replace(carriageReg, "");

							$("#docPreview").contents().find('#footer .textblock').html(content.trim());
						},
						minHeight: 150,
						shortcuts: false,
						tidyHtml: false,
						removeEmptyTags: false,
						linebreaks: true,
						buttons: [
							'html', '|', 'bold', 'italic', 'underline', 'deleted', '|',
							'unorderedlist', 'orderedlist', 'indent', 'outdent', '|',
							'image', 'table', 'link', '|', 'alignment', '|', 'horizontalrule'
						],
						plugins: ['fontsize', 'fontfamily', 'fontcolor', 'proposalRelatedTags', 'proposalLinkedTags', 'proposalCommonsTags']
					};


					$('.footredactor').redactor(redactorOpts);
					break;
			}
			
			$('#proposal_'+type+'_logotype').bind('change', function(){
				var val = $(this).val();
				
				if(val == 'custom'){
					$('#'+type+'_params .filechoose').show();
					$('#'+type+'_params .placeholder').hide();
				}else{
					$('#'+type+'_params .filechoose').hide();
					if($('#proposal_'+type+'_logourl').val() == ''){
						$('#'+type+'_params .placeholder').show();
						$('#'+type+'_params .logopreview img').hide();
					}else{
						
						$('#'+type+'_params .logopreview img').attr('src', $('#proposal_'+type+'_logourl').val());
					}
					$('#docPreview').contents().find('#'+type+' .logoblock img').attr('src', $('#proposal_'+type+'_logourl').val()).css('max-width', '100%');
				}
			});
			
			$('#proposal_'+type+'_logoposition').bind('change', function(){
				var val = $(this).val();
				
				switch(val){
					case 'left' : 
						$('#docPreview').contents().find('#'+type+' .logoblock').css('text-align', 'left');
						
						var $logoblock = $('#docPreview').contents().find('#'+type+' .logoblock').clone();
						$('#docPreview').contents().find('#'+type+' .logoblock').remove();
						
						$logoblock.prependTo($('#docPreview').contents().find('#'+type+' .row'));
						
						break;
					case 'right' : 
						$('#docPreview').contents().find('#'+type+' .logoblock').css('text-align', 'right');
						
						var $logoblock = $('#docPreview').contents().find('#'+type+' .logoblock').clone();
						$('#docPreview').contents().find('#'+type+' .logoblock').remove();
						
						$logoblock.appendTo($('#docPreview').contents().find('#'+type+' .row'));
						break;
					case 'center' : 
						$('#docPreview').contents().find('#'+type+' .logoblock').css('text-align', 'center');
						break;
				}
				
			});
			
			$('#proposal_'+type+'_logotype').trigger('change');
		});
		
	},
	
	
	updateLogo : function (elt, type) {

		var formID = 'imageForm';

		var imageData = {'image': ''};
		var data = $.extend(imageData, {action: 'imageForm', linkedtype : 'proposal',  linkedid : ProposalBuilder.structure.propdoc});

		var options = {
			title: Loc.g('Choisir une image'),
			buttons:
					[
						{
							"class": "btn btn-success",
							text: Loc.g("Enregistrer"),
							click: function () {
								$("#" + formID).submit();
							}
						},
						{
							"class": "btn btn-default",
							text: Loc.g("Annuler"),
							click: function () {
								$(this).dialog("close");
							}
						}
					],
			width: 980,
			callback: function () {
				$('.file-selector .nano').nanoScroller({preventPageScrolling: true});

				var formOpts = {
					data: {action: 'recordImage', linkedtype : 'proposal',  linkedid : ProposalBuilder.structure.propdoc},
					dataType: 'json',
					success: function (data) {

						var formOK = MyForm.processJson(data, formID);
						if (formOK) {
							$('#proposal_'+type+'_imagetype').val(data.image.imageType);
							$('#proposal_'+type+'_imageurl').val(data.image.url);
							
							$('#'+type+'_params .logopreview img').attr('src', data.image.url).show();
							$('#'+type+'_params .logopreview .placeholder').hide();
							
							$('#docPreview').contents().find('#'+type+' .logoblock img').attr('src', data.image.url).css('max-width', '100%');

							MyWindow.close();
						}

					}
				};

				MyForm.prepare(formID, 'imagePicker', formOpts, true);
			}
		};

		MyWindow.load('imagePicker', data, options);
	},
	
	changeSenderAaddress : function(item){
		if($('#proposal_senderAddress').val() == item.id){
			$('#docPreview').contents().find('#address .senderAddress').show();
			$('#docPreview').contents().find('#address .senderAddressContent').html(item.formatted.replace(/-/, '<br />'));
		}
	},
	
	deleteSenderAddress : function(item){
		$('#docPreview').contents().find('#address .senderAddressContent').html('');
		$('#docPreview').contents().find('#address .senderAddress').hide();
	},
	
	bindAddressEvents : function(){
		$('#proposal_hasAddress').bind('change', function(){
			
			if($(this).is(':checked')){
				$("#docPreview").contents().find('#address').slideDown();
				$('#address_params .addressForm').show();
			}else{
				$("#docPreview").contents().find('#address').slideUp();
				$('#address_params .addressForm').hide();
			}
		});
		
		$('#proposal_recipientName').bind('keyup', function(){
			$('#docPreview').contents().find('#recAddressName').html($(this).val());
		});
		
		$('#proposal_recipientAddressOnLeft').bind('change', function(){
			
			var $recAddress = $('#docPreview').contents().find('#recipientAddress').clone();
			$('#docPreview').contents().find('#recipientAddress').remove();
			
			if($(this).is(':checked')){
				$recAddress.removeClass('col-md-offset-1 col-sm-offset-1');
				$('#docPreview').contents().find('#senderAddress').addClass('col-md-offset-1 col-sm-offset-1');
				$recAddress.insertBefore($('#docPreview').contents().find('#senderAddress'));
			}else{
				$('#docPreview').contents().find('#senderAddress').removeClass('col-md-offset-1 col-sm-offset-1');
				$recAddress.addClass('col-md-offset-1 col-sm-offset-1');
				$recAddress.insertAfter($('#docPreview').contents().find('#senderAddress'));
			}
			
		});
		
		$('#proposal_displayContactOnAddress').bind('change', function(){
			if($(this).is(':checked')){
				$('#docPreview').contents().find('#recipientAddressContact').removeClass('inactive');
			}else{
				$('#docPreview').contents().find('#recipientAddressContact').addClass('inactive');
			}
		});
		
		$('#proposal_senderName').bind('change', function(){
			
			if($(this).val() == 'logo'){
				$('#docPreview').contents().find('#senderAddressName .logo').removeClass('inactive');
				$('#docPreview').contents().find('#senderAddressName .name').addClass('inactive');
			}else{
				$('#docPreview').contents().find('#senderAddressName .logo').addClass('inactive');
				$('#docPreview').contents().find('#senderAddressName .name').removeClass('inactive');
			}
			
		});
		$('#proposal_displaySender').bind('change', function(){
			
			if($(this).is(':checked')){
				$('#docPreview').contents().find('.senderAddress').fadeIn('fast');
			}else{
				$('#docPreview').contents().find('.senderAddress').fadeOut('fast');
			}
			
		});
	},
	
	
	editAddress: function(source, fromPurchase){
		
		var action	= "proposal_builder";
		var title	= Loc.g("Adresse du contact"); 
		
		var options = {
			title	: title,
			buttons	: [
				{text : Loc.g("Annuler"), click : function(){$(this).dialog("close")}},
				{text : Loc.g("Enregistrer"), click : function(){$("#docAddressForm").submit();}}
			],
			callback	: function(){
				
				var formId = "docAddressForm";
		
				var options = {
					success : function(data) {
						var formIsOk = MyForm.processJson(data, "addressForm");
						if (formIsOk) {
							if (data.target) {
								var addressDetails = {};
								var fieldToLoad = new Array("name", "part1", "part2", "part3", "part4", "zip", "town", "countrycode", "state");
								var field = null;
								var prefix = 'proposal_address_';


								for (var f = 0; f < fieldToLoad.length; f++) {
									var field	= fieldToLoad[f];
									var fvalue	= data.fields[field];

									if( Utils.exists(prefix + field)){
										$("#" + prefix + field).val(fvalue);
									}
								}

								if (data.addrid) {
									$("#" + prefix + 'originalid').val(data.addrid);
								}else{
									$("#" + prefix + 'originalid').val('0');
								}
								
								$("#"+prefix+'toHTML').html(data.toHTML);
								$('#docPreview').contents().find('#address #recAddressContent').html(data.toHTML);

							}
							MyWindow.close();
						}
					}, 
					data	 : {action : 'recordAddress'},
					dataType : "json"
				};
				MyForm.prepare(formId, action, options, true);
				MyFacture.initEvent();
			}
		};
		
		var prefix = 'proposal_address_';
		
		var fileOpts = {
			action	: "addressForm", 
			src		: source
		};
		
		fileOpts.thirdid	= $("#proposal_linkedid").val();
		fileOpts.selected	= $("#"+prefix+"originalid").val();
		fileOpts.countrycode= $("#"+prefix+"countrycode").val();
		
		MyWindow.load(action, fileOpts, options);
	},
	
	docplaceholder			: '<div class="placeholder">'+Loc.g('Aucun document paramétré')+'<br />'+Loc.g('Cliquez sur <i class="fa fa-edit"><xsl:comment /></i> et sélectionnez un document')+'</div>',
	docplaceholdertpl		: '<div class="placeholder">'+Loc.g('Vous avez paramétré votre widget sur "lignes du document lié"')+'<br />'+Loc.g('L‘aperçu n‘est pas disponible sur les modèles redactor')+'</div>',
	docpreloader			: '<div class="preloader" style="position:absolute;top:0;left;0;width:100%;height:100%;background:rgba(255,255,255,0.9);text-align:center;"><i class="fa fa-spin fa-spinner"></i></div>',
	insertdocplaceholder	: '<div class="placeholder">'+Loc.g('Vous avez paramétré votre widget "Document", il sera inséré à cette place')+'<br />'+Loc.g('L‘aperçu n‘est pas disponible sur l‘éditeur')+'</div>',
	
	addDocument : function(item){
		var blockID		= $("#emailBlockForm").find('#blockID').val();
		var blockType	= ProposalBuilder.structure.blocks[blockID].type;
		var docid		= item.id.split('_');
		
		
		
		if(item.name != ProposalBuilder.structure.blocks[blockID].data.docname){
			if(blockType == 'document'){
				$('#docPreview').contents().find('#block-'+blockID+' .contentdoc').html(ProposalBuilder.insertdocplaceholder);
			}else{
				$.ajax({
					url		: '/?_f=proposal_builder',
					type	: 'POST',
					dataType: 'json',
					data	: {action : 'renderDocRows', docid : docid[1], doctype : item.doctype},
					beforeSend : function(){
						$('#docPreview').contents().find('#block-'+blockID).append(ProposalBuilder.docpreloader);
					},
					success : function(data){
						$('#docPreview').contents().find('#block-'+blockID+' .preloader').remove();
						if(data.status == 'ok'){
							$('#docPreview').contents().find('#block-'+blockID+' .contentdoc').html(data.docrows);
						}else{
							$('#docPreview').contents().find('#block-'+blockID+' .contentdoc').html(ProposalBuilder.docplaceholder);
							MyWindow.alert(data.msg, {type : 'error'});
						}
					}
				});
			}
			
		}
		ProposalBuilder.structure.blocks[blockID].data.docname = item.name;
	},
	
	deleteDocument : function(item){
		var blockID = $("#emailBlockForm").find('#blockID').val();
		var blockType	= ProposalBuilder.structure.blocks[blockID].type;
		
		ProposalBuilder.structure.blocks[blockID].data.docname	= '';
		ProposalBuilder.structure.blocks[blockID].data.docid	= '';
		
		$('#docPreview').contents().find('#block-'+blockID+' .contentdoc').html(ProposalBuilder.docplaceholder);
		
	},
	
	changeDocDisplay : function(element){
		var blockID		= $("#emailBlockForm").find('#blockID').val();
		var blockType	= ProposalBuilder.structure.blocks[blockID].type;
		
		var val = $(element).val();
		
		switch(val){
			case 'related' : 
				$('#emailBlockForm .form-group:eq(1)').hide();
				$('#emailBlockForm #docid').tokenInput('clear');
				
				ProposalBuilder.structure.blocks[blockID].data.docid	= '';
				ProposalBuilder.structure.blocks[blockID].data.docname	= '';
				
				if(blockType == 'document'){
					$('#docPreview').contents().find('#block-'+blockID+' .contentdoc').html(ProposalBuilder.insertdocplaceholder);
				}else{
					$.ajax({
						url		: '/?_f=proposal_builder',
						type	: 'POST',
						dataType: 'json',
						data	: {action : 'renderDocRows', docid : $('#proposal_relatedid').val(), proposaltype : $('#proposal_type').val()},
						beforeSend : function(){
							$('#docPreview').contents().find('#block-'+blockID).append(ProposalBuilder.docpreloader);
						},
						success : function(data){
						$('#docPreview').contents().find('#block-'+blockID+' .preloader').remove();
							$('#docPreview').contents().find('#block-'+blockID+' .preloader').remove();

							if(data.status == 'ok'){
								$('#docPreview').contents().find('#block-'+blockID+' .contentdoc').html(data.docrows);
							}else{

								if($('#proposal_type').val() == 'proptemplate'){
									$('#docPreview').contents().find('#block-'+blockID+' .contentdoc').html(ProposalBuilder.docplaceholdertpl);
								}else{
									$('#docPreview').contents().find('#block-'+blockID+' .contentdoc').html(ProposalBuilder.docplaceholder);
									MyWindow.alert(data.msg, {type : 'error'});
								}
							}
						}
					});
				}
				
				
				break;
			case 'custom' : 
				ProposalBuilder.deleteDocument(false);
				$('#emailBlockForm .form-group:eq(1)').show();
				break;
		}
	},
	
	changeSignPosition : function(element){
		
		var blockID = $(element).closest('form').find('#blockID').val();
		var block	= $('#docPreview').contents().find('#block-'+blockID);
		var val		= $(element).val();
		
		ProposalBuilder.structure.blocks[blockID].data.align = val;
		
		switch(val){
			case 'left' : 
				block.find('.sign').removeClass('col-xs-offset-6 col-sm-offset-6 col-md-offset-6 col-lg-offset-6');
				break;
			case 'right' : 
				block.find('.sign').addClass('col-xs-offset-6 col-sm-offset-6 col-md-offset-6 col-lg-offset-6');
				break;
		}
	},
	
	updateTOC : function(element){
		var blockID = parseInt($(element).closest('form').find('#blockID').val(), 10);
		
		ProposalBuilder.updateTOCBlock(blockID);
	},
	
	updateTOCBlock : function(blockID){
		
		var headingsCol = [];
		
		for(var i in ProposalBuilder.structure.blocks){
			var block = ProposalBuilder.structure.blocks[i];
			if(block.type == 'heading'){
				headingsCol[block.rank] = block;
			}
		}
		
		var domtoc = $("#docPreview").contents().find('#block-'+blockID+' .toc');
		
		domtoc.empty();
		
		for(var i in headingsCol){
			var $li = $('<li class="toc-entry"></li>');
			
			$li.text(headingsCol[i].data.title);
			$li.addClass('level-'+headingsCol[i].data.level)
			
			$li.appendTo(domtoc);
			
			
		}
	},
	
	addPDF : function(position){
		var options = {
			title: (position == 'firstPage' ? Loc.g('Ajouter un document au début') : Loc.g('Ajouter un document à la fin')),
			buttons:
					[
						{
							text: Loc.g("Annuler"),
							click: function () {
								$(this).dialog("close");
							}
						}
					],
			width: 300,
			height: 315,
			callback: function () {
				$('.qq-upload-drop-area').insertBefore($('.qq-upload-button'));
				
			}
		};

		MyWindow.load('proposal_builder', {action : "pdfuploader", position : position}, options);
	},
	
	addPDFCallback : function(data, position) {	
		MyWindow.close();
		
		var divid = position == 'firstPage' ? 'proposal_prependFileId' : 'proposal_appendFileId';
		
		if (data.success){
			$('#'+divid).tokenInput("add", {id:data.file_infos.file_id , name:data.file_infos.file_fullname});		
			$('.qq-upload-list').css({'max-width' : "300px"});
		} else {
			if (data.file_infos !== undefined && data.file_infos.file_id !== undefined){
				$('#'+divid).tokenInput("add", {id:data.file_infos.file_id , name:data.name});
				$('.qq-error-message').html("<span class='qq-error-fileadded'>"+Loc.g('Le fichier existe déjà et a été lié')+"</div>");
				$('.qq-upload-list').css({'max-width' : "450px"});
			}
		}
	},
	
	
	updateContactOnAddress : function(item){
		$('#docPreview').contents().find("#recipientAddressContact .contactName").html(item.name);
	},
	
	removeContactOnAddress : function(item){
		$('#docPreview').contents().find("#recipientAddressContact .contactName").empty();
		$('#proposal_displayContactOnAddress:checked').removeAttr('checked');
		$('#proposal_displayContactOnAddress').trigger('change');
	}
};